import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import IndependentStudyCard from '../independent-study-card/independent-study-card';
import { independentStudyApi } from '@/providers/apis/independent-study/independent-study';

@Component({
  name: 'independent-program-list',
  components: {
    'independent-study-card': IndependentStudyCard,
  },
})


export default class IndependentProgramList extends Vue {
  @Prop()
  public dataLength: any;
  public isLoading: any = false;
  public offset: any = 0;
  public limit: any = 10;
  @Prop()
  public programList: any;
  @Prop()
  public totalCount: any;
  public independentProgramCard: any = [];


  private openEditProgam: boolean = false;
  public onLoadMore(event: any) {
    const { scrollTop, offsetHeight, scrollHeight } = event.target;
    if (scrollTop + offsetHeight >= scrollHeight && !this.isLoading && this.totalCount > this.programList.length) {
      this.isLoading = true;
      this.$emit('loadMore');
    }
  }
  public onClickProgramCard(item: any) {
    this.$emit('onClickProgramCard', item);
  }
  @Watch('programList')
  private changeFilter(value: any) {
    this.independentProgramCard = this.programList;
    this.isLoading = false;
  }
  private async created() {
    const params = {
      offset: this.offset,
      limit: this.limit,
    };
    if (this.programList.length) {
      this.independentProgramCard = this.programList;
    }
  }
}
